const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/get-available-languages.action';
            binding.dataActions[actionPath] = require('partner/actions/get-available-languages.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-user-data-and-addresses.action';
            binding.dataActions[actionPath] = require('partner/actions/get-user-data-and-addresses.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/set-user-data-and-addresses.action';
            binding.dataActions[actionPath] = require('partner/actions/set-user-data-and-addresses.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/validate-email-code.action';
            binding.dataActions[actionPath] = require('partner/actions/validate-email-code.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/validate-vat.action';
            binding.dataActions[actionPath] = require('partner/actions/validate-vat.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/verify-email.action';
            binding.dataActions[actionPath] = require('partner/actions/verify-email.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };